import { createRsrcKey } from 'infra/redux/reducers'
import { getResourceName } from 'features/resources'
import { getHTMLDataTestID } from 'infra/utils'
import { createDataSelectorHook } from 'infra/redux'
import { Button, TargetIcon } from 'procyon-ui'
import React from 'react'

const useSlices = createDataSelectorHook(['adDomainControllers'])

export const useADDomainControllers = ({ onEdit, onDelete }) => {
  const {
    slices: { adDomainControllers }
  } = useSlices()

  const tableData = adDomainControllers.map((item) => {
    const name = getResourceName(item)

    return {
      id: createRsrcKey(item),
      name,
      username: item.Spec.Username,
      defaultFor: (item.Spec.DefaultFor && item.Spec.DefaultFor.Elems) || [],
      rotatePassword: item.Spec.RotatePasswords,
      isLocal: item.Spec.IsLocal,
      actions: {
        onEdit: () => onEdit({ name, raw: item }),
        onDelete: () => onDelete(item)
      }
    }
  })

  return { tableData }
}

export const columns = [
  {
    dataIndex: 'name',
    title: 'Name',
    render: (val) => (
      <div data-testid={getHTMLDataTestID('ad-domain', 'div', val)} className='break-all'>
        {val}
      </div>
    )
  },
  {
    dataIndex: 'username',
    title: 'Username',
    render: (val) => <div data-testid={getHTMLDataTestID('ad-domain', 'div', val)}>{val}</div>
  },
  {
    dataIndex: 'defaultFor',
    title: 'Default For',
    render: (values) => (
      <div className='flex gap-2'>
        {values && values.length > 0 ? (
          values.map((e) => <TargetIcon key={e} type={e} width='32px' />)
        ) : (
          <span className='text-gray-400'>None</span>
        )}
      </div>
    )
  },
  {
    dataIndex: 'rotatePassword',
    title: 'Rotate Password',
    render: (val) => <span>{val ? 'Enabled' : 'Disabled'}</span>
  },
  {
    dataIndex: 'isLocal',
    title: 'Local User',
    render: (val) => <span>{val ? 'Yes' : 'No'}</span>
  },
  {
    dataIndex: 'actions',
    title: 'Actions',
    render: ({ onEdit, onDelete }) => (
      <div className='flex gap-2'>
        <Button
          data-testid={getHTMLDataTestID('ad-domain-controller', 'button', 'edit')}
          variant='grayBlue'
          onClick={onEdit}
        >
          Edit
        </Button>

        <Button
          data-testid={getHTMLDataTestID('ad-domain-controller', 'button', 'delete')}
          variant='grayRed'
          onClick={onDelete}
        >
          Delete
        </Button>
      </div>
    )
  }
]
